import { collection, doc, getDoc, getDocs, addDoc, deleteDoc, setDoc } from 'firebase/firestore';
import { getDbInstance } from '../firebase';

// Everything lives under users/{uid} so the owner-only Firestore rules cover it.
const entriesRef = (uid) => collection(getDbInstance(), 'users', uid, 'fitnessEntries');
const profileRef = (uid) => doc(getDbInstance(), 'users', uid, 'fitnessProfile', 'main');

// Entry fields, in form/table order. Weight in lb, lengths in inches.
export const MEASUREMENTS = [
  { key: 'weight', label: 'Weight', unit: 'lb' },
  { key: 'height', label: 'Height', unit: 'in' },
  { key: 'chest', label: 'Chest', unit: 'in' },
  { key: 'waist', label: 'Waist', unit: 'in' },
  { key: 'hips', label: 'Hips', unit: 'in' },
  { key: 'neck', label: 'Neck', unit: 'in' },
  { key: 'arms', label: 'Arms', unit: 'in' },
  { key: 'thighs', label: 'Thighs', unit: 'in' },
];

// Oldest first; same-day entries keep the order they were logged in.
export async function loadEntries(uid) {
  const snap = await getDocs(entriesRef(uid));
  return snap.docs
    .map(d => ({ id: d.id, ...d.data() }))
    .sort((a, b) => a.date.localeCompare(b.date) || (a.createdAt || 0) - (b.createdAt || 0));
}

export async function addEntry(uid, entry) {
  const data = { ...entry, createdAt: Date.now() };
  const ref = await addDoc(entriesRef(uid), data);
  return { id: ref.id, ...data };
}

export const deleteEntry = (uid, id) => deleteDoc(doc(entriesRef(uid), id));

export async function loadProfile(uid) {
  const snap = await getDoc(profileRef(uid));
  return snap.exists() ? snap.data() : {};
}

export const saveProfile = (uid, profile) => setDoc(profileRef(uid), profile, { merge: true });
